import { dafAnalyticsActionType } from '../../constants';

const initialState = {
    data: {
        created_members: {
            items: [],
            total: 0
        },
        members_with_cartes: {
            items: [],
            total: 0
        },
        books_in_stock: {
            items: [],
            total: 0
        },
        cards_expiring_30_days: {
            items: [],
            total: 0
        },
        cards_expiring_7_days: {
            items: [],
            total: 0
        },
        expired_cards: {
            items: [],
            total: 0
        }
    },
    loading: false,
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case dafAnalyticsActionType.FETCH_CREATED_MEMBERS:
            return {
                ...state,
                data: {
                    ...state.data,
                    created_members: action.payload.created_members
                }
            };
        case dafAnalyticsActionType.FETCH_MEMBERS_WITH_CARDS:
            return {
                ...state,
                data: {
                    ...state.data,
                    members_with_cartes: action.payload.members_with_cartes
                }
            };
        case dafAnalyticsActionType.FETCH_BOOKS_IN_STOCK:
            return {
                ...state,
                data: {
                    ...state.data,
                    books_in_stock: action.payload.books_in_stock
                }
            };
        case dafAnalyticsActionType.FETCH_CARDS_EXPIRING_30_DAYS:
            return {
                ...state,
                data: {
                    ...state.data,
                    cards_expiring_30_days: action.payload.cards_expiring_30_days
                }
            };
        case dafAnalyticsActionType.FETCH_CARDS_EXPIRING_7_DAYS:
            return {
                ...state,
                data: {
                    ...state.data,
                    cards_expiring_7_days: action.payload.cards_expiring_7_days
                }
            };
        case dafAnalyticsActionType.FETCH_EXPIRED_CARDS:
            return {
                ...state,
                data: {
                    ...state.data,
                    expired_cards: action.payload.expired_cards
                }
            };
        case dafAnalyticsActionType.FETCH_BOOKS_IN_STOCK:
            return {
                ...state,
                data: {
                    ...state.data,
                    books_in_stock: action.payload.books_in_stock
                }
            };
        default:
            return state;
    }
};
